import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Question } from "../../components";

class QuestionResultPage extends Component {

  render() {
    const questionNumber = this.props.match.params.id;
    const { result } = this.props;

    return (
      <div className="wrapper">
        <div className="content" style={{ position: "relative" }}>
          <div
            className="question__close-button"
            onClick={() => this.props.history.push("/resultado")}
          >
            <i className="icon-cross" />
          </div>
          <h2 className="inverse text-center">Análise questão</h2>
          <div className="grid-x grid-margin-x align-middle">
            <div className="small-12 medium-8 cell exam-container mt-4">
              <Question
                data={result.questoes[Number(questionNumber) - 1]}
                number={questionNumber}
                result
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  result: state.exam.result
});

export default connect(mapStateToProps, {})(QuestionResultPage);
